import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../infrastructure/api/client";
import { ApiError, type UserSettingsDto, type UpdateUserSettingsDto } from "@tabipla/shared";

// Query keys
const settingsKeys = {
  all: ["settings"] as const,
  user: () => [...settingsKeys.all, "user"] as const,
};

// Get user settings
export function useSettings() {
  return useQuery({
    queryKey: settingsKeys.user(),
    queryFn: async () => {
      const response = await apiClient.get<UserSettingsDto>("/api/users/settings");
      if (!response.success) {
        throw ApiError.fromResponse(response.error, "Failed to fetch settings");
      }
      return response.data!;
    },
  });
}

// Update user settings
export function useUpdateSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UpdateUserSettingsDto) => {
      const response = await apiClient.patch<UserSettingsDto>("/api/users/settings", data);
      if (!response.success) {
        throw ApiError.fromResponse(response.error, "Failed to update settings");
      }
      return response.data!;
    },
    onSuccess: (updatedSettings) => {
      queryClient.setQueryData(settingsKeys.user(), updatedSettings);
    },
  });
}
